import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import {
  type ContactPreviewPopoverDataProps,
  contactPreviewPopoverDataSchema,
} from "./ContactPreviewPopover.schema";
import { ContactPreviewPopover } from "./components/ContactPreview";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    "contact-preview-popover": {
      props: ContactPreviewPopoverDataProps;
      handle: undefined;
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-contact-preview-popover": HTMLElement;
  }
}

export function RWCContactPreviewPopover(
  props: ContactPreviewPopoverDataProps,
): JSX.Element {
  return <ContactPreviewPopover {...props} />;
}

componentManager.register(
  rwc("contact-preview-popover", {
    component: RWCContactPreviewPopover,
    dataSchema: contactPreviewPopoverDataSchema,
  }),
);
